import _isEmpty from "lodash/isEmpty";
import store from "@/store/index";
import { isValidUuidV4 } from "@/utils/helpers";

const state = {
    showLoader: false,
    isDoingMonetaryActivity: false,
    nonfictionCampaign: {},
    nonfictionCampaignBenefits: [
        "Unlimited access to all Book Insights",
        "All titles available as both text and audio",
        "Learn from the best nonfiction books in 30 minutes"
    ],
    nonfictionCampaignGifts: [],
    nonfictionSelectedGift: {},
    currentFacebookPixel: "",
    profileGroup: "",
    showSubscribeBtn: false
};

const mutations = {
    SHOW_LOADER(state, shouldShow) {
        state.showLoader = shouldShow;
    },
    SET_DEFAULT_NONFICTION_CAMPAIGN(state, nonfictionCampaign = {}) {
        state.nonfictionCampaign = nonfictionCampaign;
    },
    SET_MONETARY_ACTIVITY(state, isDoingMonetaryActivity) {
        state.isDoingMonetaryActivity = isDoingMonetaryActivity;
    },
    SET_GIFTS(state, info) {
        state[info.stateProperty] = info.audibooks;
    },
    SET_SELECTED_NONFICTION_GIFT(state, giftId) {
        state.nonfictionSelectedGift = giftId;
    },
    CLEAN_UP_DATA(state) {
        state.nonfictionSelectedGift = {};
    },
    SET_CURRENT_FACEBOOK_PIXEL(state, currentFacebookPixel) {
        state.currentFacebookPixel = currentFacebookPixel;
    },
    SET_PROFILE_GROUP(state, profileGroup = "") {
        state.profileGroup = profileGroup;
    },
    SET_SHOW_SUBSCRIBE_BTN(state, showSubscribeBtn = false) {
        state.showSubscribeBtn = showSubscribeBtn;
    }
};

const actions = {
    async getGlobalStateData({ dispatch, state }) {
        if (!Cookies.get("token") || !isValidUuidV4(Cookies.get("token"))) {
            if (_isEmpty(state.nonfictionCampaign)) {
                await dispatch("updateDefaultNonfictionCampaign");
            }
            return new Promise((resolve, reject) => {
                reject("ERROR");
            });
        }
        return Promise.all([
            dispatch("User/getData", null, { root: true }),
            dispatch("UserMembership/getData", null, { root: true }),
            // dispatch("UserWallet/getData", null, { root: true }),
            dispatch("UserLibrary/getData", null, { root: true }),
            dispatch("updateDefaultNonfictionCampaign")
        ]);
    },
    resetGlobalData({ commit, dispatch }) {
        dispatch("User/cleanUpData", {}, { root: true });
        dispatch("UserMembership/cleanUpData", {}, { root: true });
        // dispatch("UserWallet/cleanUpData", {}, { root: true });
        dispatch("UserLibrary/cleanUpData", {}, { root: true });
        commit("CLEAN_UP_DATA");
        dispatch("setSelectedNonfictionGift", {});
    },
    showLoader({ commit }, shouldShow) {
        commit("SHOW_LOADER", shouldShow);
    },
    setDefaultNonfictionCampaign({ commit, dispatch }, nonfictionCampaign) {
        commit("SET_DEFAULT_NONFICTION_CAMPAIGN", nonfictionCampaign);
        if (Array.isArray(nonfictionCampaign.audiobooks)) {
            dispatch("updateGifts", { stateProperty:"nonfictionCampaignGifts", audiobooksId: nonfictionCampaign.audiobooks })
        }
        const selectedGiftId = JSON.parse(sessionStorage.getItem("nonfictionSelectedGift"));
        if (!_isEmpty(selectedGiftId)) {
            commit("SET_SELECTED_NONFICTION_GIFT", selectedGiftId);
        }
    },
    setDefaultCampaign({ dispatch }, campaign) {
        if (campaign.membership_type == "NonFiction") {
            dispatch("setDefaultNonfictionCampaign", campaign);
        }
    },
    getDefaultNonfictionCampaign({ }) {
        return axios.get(`v2/campaign/nonfiction/default`)
    },
    getCampaign({ }, campaignId) {
        return axios.get(`/v2/campaign/${campaignId}`)
    },
    // eslint-disable-next-line
    updateGifts({ commit }, info) {
        return new Promise((resolve) => {
            axios.get(`v2/audiobooks/${info.audiobooksId.join(",")}`).then(({ data }) => {
                commit("SET_GIFTS", { stateProperty: info.stateProperty, audibooks: data });
                resolve({ stateProperty: info.stateProperty, audibooks: data });
            }).catch(() => resolve());
        })
    },
    updateDefaultHibooksCampaign({ dispatch }) {
        return new Promise((resolve) => {
            dispatch("getDefaultHibooksCampaign").then(({ data }) => {
                dispatch("setDefaultHibooksCampaign", data);
                resolve(data);
            });
        })
    },
    updateDefaultNonfictionCampaign({ dispatch }) {
        return new Promise((resolve) => {
            dispatch("getDefaultNonfictionCampaign").then(({ data }) => {
                dispatch("setDefaultNonfictionCampaign", data);
                resolve(data);
            });
        })
    },
    updateDefaultCampaign({ dispatch }, campaignId) {
        return new Promise((resolve) => {
            dispatch("getCampaign", campaignId).then(({ data }) => {
                dispatch("setDefaultCampaign", data);
                resolve(data);
            });
        });
    },
    setMonetaryActivity({ commit }, isDoingMonetaryActivity) {
        commit("SET_MONETARY_ACTIVITY", isDoingMonetaryActivity);
    },
    setSelectedNonfictionGift({ commit }, gift) {
        sessionStorage.setItem("nonfictionSelectedGift", JSON.stringify(gift));
        commit("SET_SELECTED_NONFICTION_GIFT", gift);
    },
    setProfileGroup({ commit }, profileGroup = "") {
        commit("SET_PROFILE_GROUP", profileGroup);
    },
    setSubscribeBtnVisibility({ commit }, showSubscribeBtn = false) {
        commit("SET_SHOW_SUBSCRIBE_BTN", !showSubscribeBtn);
    }
};

const getters = {
    isStateReady() {
        return !_isEmpty(store.User.state.data);
    },
    isLoading(state) {
        return state.showLoader;
    },
    isDoingMonetaryActivity(state) {
        return state.isDoingMonetaryActivity;
    },
    mobilePlatforms() {
        return ["ios", "android"];
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
